<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('car_reservations_empty_reservations')"
                        :isColumns="true"
                        @filter-div-status="datatable.filterStatus = $event">
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column,key) in datatable.columns">
                            <b-form-checkbox
                                :id="'checkbox-'+key"
                                :name="'checkbox-'+key"
                                :value="false"
                                :unchecked-value="true"
                                v-model="column.hidden"
                                v-if="column.field!='buttons'"
                            >
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('car_reservations_empty_reservations')"
                              :isColumns="true"
                              @filter-div-status="datatable.filterStatus = $event">
                    <div class="mb-1" v-for="(column,key) in datatable.columns">
                        <b-form-checkbox
                            :id="'checkbox-'+key"
                            :name="'checkbox-'+key"
                            :value="false"
                            :unchecked-value="true"
                            v-model="column.hidden"
                            v-if="column.field!='buttons'"
                        >
                            {{ column.label }}
                        </b-form-checkbox>
                    </div>
                </HeaderMobile>
            </template>

            <datatable-filter v-show="datatable.filterStatus"
                              @filter="filter"
                              @filterClear="filterClear"
            >
                <ValidationObserver ref="formModalValidate">
                    <b-row>
                       <b-col cols="12" md="6">
                            <ValidationProvider name="start_date" rules="required" v-slot="{ valid, errors }">
                                <b-form-group :label="$t('start_date')">
                                    <select-date v-model="datatable.queryParams.start_date" :state="errors[0] ? false : null" :is-time="true"/>
                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="6">
                            <ValidationProvider name="end_date" rules="required" v-slot="{ valid, errors }">
                                <b-form-group :label="$t('end_date')">
                                    <select-date v-model="datatable.queryParams.end_date" :state="errors[0] ? false : null" :is-time="true"/>
                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="6">
                            <ValidationProvider name="car_brand_id" rules="" v-slot="{ valid, errors }">
                                <b-form-group :label="$t('car_brand')">
                                    <car-brand-selectbox v-model="datatable.queryParams.filter.car_brand_id" :state="errors[0] ? false : null" />
                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="6">
                            <ValidationProvider name="car_model_id" rules="" v-slot="{ valid, errors }">
                                <b-form-group :label="$t('car_model')">
                                    <car-model-selectbox v-model="datatable.queryParams.filter.car_model_id" :state="errors[0] ? false : null" />
                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="6">
                            <ValidationProvider name="gear" rules="" v-slot="{valid, errors}">
                                <b-form-group :label="$t('gear')">
                                    <parameter-selectbox :validate-error="errors[0]" v-model="datatable.queryParams.filter.gear"
                                                         code="car_gear_types"/>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="6">
                            <ValidationProvider name="type" rules="" v-slot="{valid, errors}">
                                <b-form-group :label="$t('type')">
                                    <parameter-selectbox :validate-error="errors[0]" v-model="datatable.queryParams.filter.type"
                                                         code="car_types"/>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                </ValidationObserver>
            </datatable-filter>

            <datatable :isLoading.sync="datatable.isLoading"
                       :columns="datatable.columns"
                       :rows="datatable.rows"
                       :total="datatable.total"
                       :queryParams="datatable.queryParams"
                       :lineNumbers="false"
                       @on-page-change="onPageChange"
                       @on-sort-change="onSortChange"
                       @on-per-page-change="onPerPageChange"
                       v-show="datatable.showTable"
            />
            <CommonModal ref="makeReservationFormModal" size="md" :onHideOnlyX="true" @bHideModalHeaderClose="formClear" v-if="checkPermission('carreservation_makereservation')">
                <template v-slot:CommonModalTitle>
                    {{ $t('make_reservation').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <reservation-form :formData="formData"
                                 @makeReservationFormSuccess="makeReservationFormSuccess"
                                 v-if="formProcess=='makeReservation'"/>
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
    //Template
    import AppLayout from '@/layouts/AppLayout';
    import Header from '@/layouts/AppLayout/Header'
    import HeaderMobile from '@/layouts/AppLayout/HeaderMobile'

    //Component
    import DatatableFilter from '@/components/datatable/DatatableFilter';
    import Datatable from '@/components/datatable/Datatable';
    import CommonModal from '@/components/elements/CommonModal';

    //Page
    import ReservationForm from './ReservationForm'

    //Service
    import CarReservationEmptyReservationService from '@/services/CarReservationEmptyReservationService';

    //Other
    import qs from 'qs';
    import CarBrandSelectbox from "@/components/interactive-fields/CarBrandSelectbox.vue";
    import CarModelSelectbox from "@/components/interactive-fields/CarModelSelectbox.vue";

    export default {
        components: {
            CarModelSelectbox,
            CarBrandSelectbox,
            AppLayout,
            Header,
            HeaderMobile,
            DatatableFilter,
            Datatable,
            CommonModal,
            ReservationForm,
        },
        metaInfo() {
            return {
                title: this.$t('car_reservations_empty_reservations')
            }
        },
        data() {
            return {
                formData: {},
                form: {},
                formProcess: null,
                datatable: {
                    isLoading: false,
                    columns: [
                        {
                            label: '',
                            field: 'buttons',
                            html: true,
                            hidden: false,
                            tdClass: 'p-0 text-center w-40 align-middle',
                            buttons: [
                                {
                                    text: this.$t('make_reservation'),
                                    class: 'ri-edit-box-line',
                                    permission: 'carreservation_makereservation',
                                    callback: (row) => {
                                        this.makeReservationFormShow(row);
                                    }
                                },
                            ]
                        },
                        {
                            label: this.toUpperCase('car_brand'),
                            field: this.getLocaleField('car_brand'),
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('car_model'),
                            field: this.getLocaleField('car_model'),
                            hidden: false
                        },
                       {
                            label: this.toUpperCase('gear'),
                            field: this.getLocaleField('gear_name'),
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('plate'),
                            field: 'plate',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('kilometer'),
                            field: 'kilometer',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('maintenance_date'),
                            field: 'maintenance_date',
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('status'),
                            field: this.getLocaleField('status_name'),
                            hidden: false
                        },
                        {
                            label: this.toUpperCase('type'),
                            field: this.getLocaleField('type_name'),
                            hidden: false
                        },
                    ],
                    rows: [],
                    total: 0,
                    filterStatus: true,
                    showTable: false,
                    queryParams: {
                        start_date: null,
                        end_date: null,
                        filter: {},
                        sort: 'id',
                        page: 1,
                        limit: 20
                    }
                },
                start_date: null,
                end_date: null,
            };
        },
        methods: {
            async filter() {
                const valid = await this.$refs.formModalValidate.validate()
                if(!valid) {
                    return
                }
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            filterClear() {
                this.datatable.queryParams.filter = {};
                this.datatable.queryParams.start_date = null;
                this.datatable.queryParams.end_date = null;
                this.getRows();
            },
            onPageChange(params) {
                this.datatable.queryParams.page = params.currentPage;
                this.getRows();
            },
            onPerPageChange(params) {
                this.datatable.queryParams.limit = params.currentPerPage;
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            onSortChange(params) {
                const sortType = params[0].type == 'desc' ? '-' : '';
                this.datatable.queryParams.sort = sortType + params[0].field;
                this.getRows();
            },
            getRows() {
                this.datatable.showTable = true;
                this.datatable.isLoading = true;

                const config = {
                    params: {
                        ...this.datatable.queryParams
                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                };

                return CarReservationEmptyReservationService.getAll(config)
                                       .then((response) => {
                                           this.datatable.rows = response.data.data;
                                           this.datatable.total = response.data.pagination.total;
                                       })
                                        .catch((error) => {
                                            const data = error.data;

                                            if (data.errors) {
                                                Object.keys(data.errors).forEach(field => {
                                                    const messages = data.errors[field];
                                                    if (Array.isArray(messages)) {
                                                        messages.forEach(msg => this.$toast.error(msg));
                                                    } else {
                                                        this.$toast.error(messages);
                                                    }
                                                });
                                                return;
                                            }
                                        })
                                       .finally(() => {
                                           this.datatable.isLoading = false;
                                       });
            },
            async makeReservationFormSuccess() {
                this.$refs.makeReservationFormModal.$refs.commonModal.hide()
                this.getRows()
                this.formClear()
            },
            makeReservationFormShow(row) {
                const start_date  = this.datatable.queryParams.start_date;
                const end_date  = this.datatable.queryParams.end_date;

                this.formData = {
                    ...row,
                    start_date,
                    end_date,
                };

                this.formProcess = 'makeReservation'
                this.$refs.makeReservationFormModal.$refs.commonModal.show()
            },
            formClear() {
                this.formData = {}
                this.formProcess = null
            },
        }
    }
</script>
